import api from '../../api'
import { endpoints } from '../../apiCommons'
import localCompany from '../localStorage/localCompany'

const discount = async ({ cEmpleados, ...rest }) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getUserData()
  return api.post(
    endpoints.balance_dicount,
    {
      ...rest,
      sEmpresa,
      nMontoTotal: cEmpleados.reduce(
        (acc, el) => acc + Number(el.nMonto) || 0,
        0,
      ),
      cEmpleados,
    },
    { headers: { token } },
  )
}

const validateDiscountMasive = async ({ cEmpleados, ...rest }) => {
  const token = localStorage.getItem('token')
  const { sEmpresa } = localCompany.getUserData()
  return api.post(
    endpoints.balance_dicount,
    {
      ...rest,
      sEmpresa,
      nMontoTotal: cEmpleados.reduce(
        (acc, el) => acc + Number(el.nMonto) || 0,
        0,
      ),
      cEmpleados,
    },
    {
      headers: { token },
      params: {
        bSoloValidar: true,
      },
    },
  )
}

export default {
  discount,
  validateDiscountMasive,
}
